module.exports = __webpack_public_path__ + "src/assets/img/AtomBomb.d5288b51.png";